import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import './Navbar.scss'
import { images } from '../../constants'

const Navbar = ({DarkMode, SetDarkMode, Page, SetPage}) => {
  const [menu, setMenu] = useState(false);
  const navigate = useNavigate();

  const handleNavigate = (item) => {
    navigate(`${item}`);
    SetPage(`${item}`);
  }

  const location = useLocation();
  useEffect(() => {
    SetPage(location.pathname);
    window.scrollTo(0, 0);
  }, [location]);

  const direct = [
    {link:'', name:'home'},
    {link:'about', name:'about'},
    {link:'work', name:'work'},
    {link:'contact', name:'contact'},
  ]

  return (
    <nav className='app__navbar'>
      <div className='app__navbar-logo' onClick={() => handleNavigate('/')}>
        <img src={DarkMode?images.blacklogo:images.blacklogo} alt="logo" />
      </div>
      <ul className='app__navbar-links'>
        { direct.map((item) => (
          <li className='app-flex p-text' key={`link-${item.link}`} onClick={() => handleNavigate(`/${item.link}`)}>
            <p className={Page===`/${item.link}`?'text-bold':''}
              style={{color: DarkMode?'var(--darkgray-color)':'var(--darkgray-color)'}}
            >{item.name}</p>
            <div className={Page===`/${item.link}`?'links-underline active':'links-underline'} style={{backgroundColor: DarkMode?'var(--darkgray-color)':'var(--darkgray-color)'}}/>
          </li>
        )) }
          {/* <li className='app__navbar-darkmode' onClick={() => SetDarkMode((c)=>(!c))} style={{color: DarkMode?'red':'blue'}}>darkmode</li> */}
      </ul>
      {/* <li className='app__navbar-darkmode-rwd' onClick={() => SetDarkMode((c)=>(!c))} style={{color: DarkMode?'red':'blue'}}>darkmode</li> */}

      <div className='app__navbar-burger' onClick={() => setMenu(!menu)}>
        <div 
          className='app__navbar-burger-line 1' 
          style={{ transform: menu? 'rotate(45deg) translate(0px,4px)' : '', background: DarkMode?'var(--darkgray-color)':'var(--darkgray-color)'}}
          />
        <div 
          className='app__navbar-burger-line 2' 
          style={{ transform: menu? 'rotate(-45deg) translate(0px,-4px)' : '', background: DarkMode?'var(--darkgray-color)':'var(--darkgray-color)'}}
          />
      </div>
      <ul 
        className='app__navbar-menu-box' 
        onClick={ () => setMenu(false) }
        style={{ right: menu? '0px' : '-390px', }}>
        { direct.map((item) => (
          <li className='app-flex p-text' key={`link-${item.link}`} onClick={() => handleNavigate(`/${item.link}`)}>
            <p className={Page===`/${item.link}`?'text-bold':''}
            >{item.name}</p>
            <div className={Page===`/${item.link}`?'links-underline active':'links-underline'} style={{backgroundColor: DarkMode?'var(--darkgray-color)':'var(--darkgray-color)'}}/>
          </li>
        )) }
      </ul>
    </nav>
  )
}

export default Navbar